/* Janma — PDP interactions (prototype) */
(function () {
  'use strict';

  /* ---- Gallery ---- */
  var main = document.getElementById('galleryMain');
  var thumbs = document.getElementById('thumbs');
  if (main && thumbs) {
    thumbs.addEventListener('click', function (e) {
      var t = e.target.closest('.gallery__thumb');
      if (!t) return;
      var full = t.getAttribute('data-full');
      if (full) {
        main.style.opacity = '0';
        // clear srcset so the responsive picker can't revert the swapped image on resize
        setTimeout(function () { main.srcset = ''; main.src = full; main.style.opacity = '1'; }, 120);
      }
      thumbs.querySelectorAll('.gallery__thumb').forEach(function (b) { b.classList.remove('is-active'); });
      t.classList.add('is-active');
    });
  }

  /* ---- Quantity steppers ---- */
  document.querySelectorAll('[data-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrap = btn.closest('.qty');
      var input = wrap && wrap.querySelector('input');
      if (!input) return;
      var v = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(btn.getAttribute('data-qty'), 10));
      input.value = v;
      // Fire 'change' so anything watching the quantity can react — without this the
      // multi-buy preset cards stayed lit on "Three" after the stepper moved to 2,
      // i.e. the card contradicted the actual quantity. (Cart steppers are a
      // different attribute, data-qty-change, so this stays PDP-only.)
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
  // Manually-typed quantity: clamp to a positive integer so the form never submits "" or 0.
  var qtyInput = document.getElementById('qty');
  if (qtyInput) qtyInput.addEventListener('change', function () {
    var v = parseInt(qtyInput.value, 10);
    qtyInput.value = (v && v > 0) ? v : 1;
  });

  /* ---- FAQ accordion ---- */
  document.querySelectorAll('.faq__q').forEach(function (q) {
    q.addEventListener('click', function () {
      var item = q.closest('.faq__item');
      var ans = item.querySelector('.faq__a');
      var open = item.classList.toggle('is-open');
      q.setAttribute('aria-expanded', open ? 'true' : 'false');
      ans.style.maxHeight = open ? (ans.firstElementChild.scrollHeight + 28) + 'px' : '0px';
    });
  });

  /* ---- Variant selection (pill → hidden <select> wiring) ----
     Single-variant products render no .opt__choices, so this is inert for them.
     For multi-variant SKUs it makes the pills authoritative: updates the hidden
     #variant-id, price/compare/save, availability, gallery image, and (when present)
     the Subscribe & Save plan options — and fires a 'pdp:variant' event the
     subscribe module listens for. */
  var optGroups = Array.prototype.slice.call(document.querySelectorAll('.opt__choices'));
  var variantSelect = document.getElementById('variant-id');
  var pdpDataEl = document.getElementById('pdp-data');
  if (optGroups.length && variantSelect && pdpDataEl) {
    var variants = [];
    try { variants = (JSON.parse(pdpDataEl.textContent) || {}).variants || []; } catch (e) { variants = []; }
    var currentSelection = function () {
      return optGroups.map(function (g) { var a = g.querySelector('.opt__choice.is-active'); return a ? a.getAttribute('data-value') : null; });
    };
    var matchVariant = function (vals) {
      return variants.filter(function (v) {
        return v.options && v.options.length === vals.length && v.options.every(function (o, i) { return o === vals[i]; });
      })[0];
    };
    var applyVariant = function (v) {
      if (!v) return;
      variantSelect.value = v.id;
      var priceEl = document.getElementById('pdp-price');
      var cmpEl = document.getElementById('pdp-compare');
      var saveEl = document.getElementById('pdp-save');
      if (priceEl) priceEl.textContent = v.now;
      if (cmpEl) { if (v.base) { cmpEl.textContent = v.base; cmpEl.style.display = ''; } else { cmpEl.style.display = 'none'; } }
      if (saveEl) { if (v.save > 0) { saveEl.textContent = 'Save ' + v.save + '%'; saveEl.style.display = ''; } else { saveEl.style.display = 'none'; } }
      var atc = document.getElementById('mainAtc');
      if (atc) {
        if (v.available) { atc.disabled = false; atc.textContent = atc.dataset.label || 'Add to cart'; }
        else { atc.disabled = true; atc.textContent = 'Sold out'; }
      }
      var expressWrap = document.querySelector('.buy__express');
      var subOn = document.querySelector('input[name="purchase"][value="subscribe"]:checked');
      if (expressWrap) expressWrap.style.display = (v.available && !subOn) ? '' : 'none';
      if (v.image) { var gm = document.getElementById('galleryMain'); if (gm) { gm.srcset = ''; gm.src = v.image; } }
      document.dispatchEvent(new CustomEvent('pdp:variant', { detail: v }));
    };
    optGroups.forEach(function (g) {
      g.addEventListener('click', function (e) {
        var b = e.target.closest('.opt__choice');
        if (!b || b.classList.contains('is-active')) return;
        g.querySelectorAll('.opt__choice').forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
        applyVariant(matchVariant(currentSelection()));
      });
    });
  }

  /* ---- Subscribe & Save (Shopify selling plans) ---- */
  var po = document.querySelector('.purchase-options');
  if (po) {
    var sp = document.getElementById('selling-plan');
    var freq = document.getElementById('plan-frequency');
    var plansWrap = po.querySelector('.po-plans');
    var priceEl = document.getElementById('pdp-price');
    var atcBtn = document.getElementById('mainAtc');
    var onceLabel = atcBtn ? atcBtn.textContent : 'Add to cart';
    var oncePrice = priceEl ? priceEl.textContent : '';
    // One-time-only price chrome (struck MRP, "Save X%" badge, auto-discount note) —
    // hidden while subscribed, since the subscription price/discount is different.
    var onceOnly = [document.getElementById('pdp-compare'), document.getElementById('pdp-save'), document.getElementById('pdp-discount-note')];
    var toggleOnceOnly = function (show) { onceOnly.forEach(function (el) { if (el) el.style.display = show ? '' : 'none'; }); };
    var applyFreq = function () {
      if (!freq || !freq.options.length) return;
      var opt = freq.options[freq.selectedIndex];
      if (sp) sp.value = opt.value;
      if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
    };
    var setMode = function (sub) {
      po.querySelectorAll('.po-card').forEach(function (c) { c.classList.remove('is-active'); });
      var card = po.querySelector(sub ? '.po-card--sub' : '.po-card--once');
      if (card) card.classList.add('is-active');
      if (plansWrap) plansWrap.hidden = !sub;
      toggleOnceOnly(!sub);
      // Razorpay Magic BuyNow (express button) can't process selling plans — hide it while subscribed.
      var express = document.querySelector('.buy__express');
      if (express) express.style.display = sub ? 'none' : '';
      if (sub) {
        applyFreq();
        if (atcBtn && !atcBtn.disabled) { atcBtn.textContent = 'Subscribe'; atcBtn.dataset.label = 'Subscribe'; }
      } else {
        if (sp) sp.value = '';
        if (priceEl) priceEl.textContent = oncePrice;
        if (atcBtn && !atcBtn.disabled) { atcBtn.textContent = onceLabel; atcBtn.dataset.label = onceLabel; }
      }
    };
    po.querySelectorAll('input[name="purchase"]').forEach(function (r) {
      r.addEventListener('change', function () { setMode(r.value === 'subscribe'); });
    });
    if (freq) freq.addEventListener('change', applyFreq);
    // Refresh the subscribe options + captured one-time price when the variant changes.
    document.addEventListener('pdp:variant', function (e) {
      var v = e.detail; if (!v) return;
      oncePrice = v.now;
      if (freq && v.plans) {
        freq.innerHTML = '';
        v.plans.forEach(function (p) { var o = document.createElement('option'); o.value = p.id; o.dataset.price = p.price; o.textContent = p.name + ' — ' + p.price; freq.appendChild(o); });
      }
      var subR = po.querySelector('input[name="purchase"][value="subscribe"]');
      if (subR && subR.checked) { applyFreq(); } else if (priceEl) { priceEl.textContent = oncePrice; }
    });
  }

  /* ---- Multi-buy quantity presets ----
     Picking a preset ONLY writes the quantity field, so the real Shopify
     automatic discount still decides the price at checkout — nothing here
     invents a discount. Kept two-way: nudging the +/- stepper re-syncs (or
     clears) the selection, so the cards can never contradict the quantity. */
  var qp = document.querySelector('.qtyp');
  if (qp) {
    var qpQty = document.getElementById('qty');
    var qpCards = qp.querySelectorAll('.qtyp__card');
    var qpRadios = qp.querySelectorAll('input[name="qtypreset"]');
    var qpPaint = function () {
      qpCards.forEach(function (c) {
        var r = c.querySelector('input[name="qtypreset"]');
        c.classList.toggle('is-active', !!(r && r.checked));
      });
    };
    qpRadios.forEach(function (r) {
      r.addEventListener('change', function () {
        if (r.checked && qpQty) {
          qpQty.value = r.value;
          qpQty.dispatchEvent(new Event('change', { bubbles: true }));
        }
        qpPaint();
      });
    });
    if (qpQty) {
      qpQty.addEventListener('change', function () {
        var v = String(parseInt(qpQty.value, 10) || 1);
        var matched = false;
        qpRadios.forEach(function (r) { if (r.value === v) { r.checked = true; matched = true; } });
        if (!matched) qpRadios.forEach(function (r) { r.checked = false; });
        qpPaint();
      });
    }
    qpPaint();
  }

  /* ---- "See the science" expander ---- */
  document.querySelectorAll('.science__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var box = btn.closest('.science');
      var body = box.querySelector('.science__body');
      var open = box.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      body.style.maxHeight = open ? body.firstElementChild.scrollHeight + 'px' : '0px';
    });
  });

  /* ---- Sticky "Add to cart" bar — appears once the main buy button scrolls out of view above ---- */
  var buyBar = document.getElementById('buyBar');
  var mainAtc = document.getElementById('mainAtc');
  // Sticky-bar "Add to cart" routes through the real buy button so it respects the
  // selected variant, Subscribe & Save plan, and quantity (not a bare quick-add).
  var buyBarAdd = document.getElementById('buyBarAdd');
  if (buyBarAdd && mainAtc) buyBarAdd.addEventListener('click', function () { mainAtc.click(); });
  var waBtn = document.querySelector('.wa-float');
  var sToast = document.getElementById('salesToast');
  if (buyBar && mainAtc && 'IntersectionObserver' in window) {
    var barIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var scrolledPast = e.boundingClientRect.top < 0; // main button has scrolled above the viewport
        var vis = !e.isIntersecting && scrolledPast;
        buyBar.classList.toggle('is-visible', vis);
        buyBar.inert = !vis; // keep it out of tab order / a11y tree while hidden off-screen
        if (waBtn) waBtn.style.bottom = vis ? '88px' : ''; // lift WhatsApp button clear of the sticky bar
        if (sToast) sToast.style.bottom = vis ? '94px' : ''; // lift the sales toast clear of the sticky bar
      });
    }, { threshold: 0 });
    barIO.observe(mainAtc);
  }
})();
